module.exports = __webpack_public_path__ + "img/sam-shirt-pride-01.e06d674e.jpg";